import React from "react";

// Renk paleti, istersen kendi renklerini ekleyebilirsin
const colors = [
  "#f44336", "#e91e63", "#9c27b0",
  "#673ab7", "#3f51b5", "#2196f3",
  "#03a9f4", "#00bcd4", "#009688",
  "#4caf50", "#8bc34a", "#cddc39",
  "#ffeb3b", "#ffc107", "#ff9800",
  "#ff5722", "#795548", "#607d8b"
];

// İsimden renk seçen fonksiyon
function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const index = Math.abs(hash) % colors.length;
  return colors[index];
}

const Avatar = ({ name }) => {
  if (!name) return null;

  const firstLetter = name.charAt(0).toUpperCase();
  const bgColor = stringToColor(name);

  const style = {
    backgroundColor: bgColor,
    width: 40,
    height: 40,
    borderRadius: "50%",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: 20,
    userSelect: "none",
  };

  return <div style={style}>{firstLetter}</div>;
};

export default Avatar;
